import { css } from 'react-emotion'

const styles = {
  wrap: css({
    backgroundColor: '#fff',
    border: '1px solid #e6e6e6',
    padding: '8px',
    flexDirection: 'column',
    display: 'flex',
    borderRadius: 4
  }),
  textArea: css({
    marginBottom: '0.7em !important'
  }),
  time: css({
    color: '#777'
  }),
  close: css({
  }),
  btnWrap: css({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center'
  }),
  submit: css({
    marginLeft: '20px !important'
  })
}

export default styles



// WEBPACK FOOTER //
// ./src/Components/VideoPlayer/CommentBox/CommentBoxStyles.js